import { Injectable } from '@angular/core';
import { AbstractFeatureAclService } from '@y42/feature/acl';
import { Y42FeatureType } from '@y42/json-schema';
import { ExportQuery } from '../../state';

@Injectable({ providedIn: 'root' })
export class ExportAclService extends AbstractFeatureAclService<Y42FeatureType.Export> {
  constructor(query: ExportQuery) {
    super({
      featureType: Y42FeatureType.Export,
      query,
    });
  }
}
